import { Box, Typography } from '@mui/material';
import StaticPage from '../../components/StaticPage';

const sections = [
    {
        h: '1. What we collect',
        body: 'Account details you provide when you sign up (name, username, email), the content you add to your brand or creator profile (bio, categories, platforms, rates, images), and standard technical data such as log data.',
    },
    {
        h: '2. Third-party platform data',
        body: 'For creator platforms you connect or list (Instagram, TikTok, YouTube and others), we may display publicly available stats such as follower counts, engagement and post sentiment to help brands evaluate a fit.',
    },
    {
        h: '3. How we use your data',
        body: 'To run the core product: showing your profile to the other side of the marketplace, powering search and AI matching, and improving the platform. We do not sell your personal data.',
    },
    {
        h: '4. Cookies & sessions',
        body: 'We use session storage to keep you signed in. We do not use third-party advertising trackers.',
    },
    {
        h: '5. Data retention',
        body: 'We keep your account and profile data for as long as your account is active. You can request deletion at any time through the Contact page.',
    },
    {
        h: '6. Your rights',
        body: 'You can review, edit or delete the information on your profile at any time from your profile page, or contact us to request a full export or deletion of your account.',
    },
    {
        h: '7. Contact',
        body: 'Questions about this policy can be sent through the Contact page.',
    },
];

export default function PrivacyPage() {
    return (
        <StaticPage title="Privacy Policy" subtitle="Last updated 2026.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {sections.map((s) => (
                    <Box key={s.h}>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>{s.h}</Typography>
                        <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>{s.body}</Typography>
                    </Box>
                ))}
            </Box>
        </StaticPage>
    );
}
